import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./index.css";

import Dashboard from "./dashboard";
import { Login } from './components/Login';
import Home from './Home';
import UserRegistration from './components/user-management';
import Report from "./components/Report";
import Troubleshooting from "./components/troubleshooting";
import ChangePassword from './components/changepassword';
import ResetPassword from './components/ResetPassword';

// Auth check
const isAuthenticated = () => {
  return !!(localStorage.getItem("username") && localStorage.getItem("usertype"));
};

// Route that only renders children if authenticated
const ProtectedRoute = () => {
  return isAuthenticated() ? <Outlet /> : <Navigate to="/login" replace />;
};

const Resetauthentication = () => {
  const isAdmin = localStorage.getItem('username') === 'admin';
  return isAdmin ? <Outlet /> : <Navigate to="/login" replace />;
};



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HashRouter>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<Home />}>
          <Route index element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="user-management" element={<UserRegistration />} />
          <Route path="report" element={<Report />} />
          <Route path="troubleshooting" element={<Troubleshooting />} />
          <Route element={<Resetauthentication />}>
            <Route path="resetpassword" element={<ResetPassword />} />
          </Route>
        </Route>
      </Route>
      <Route path="changepassword" element={<ChangePassword />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  </HashRouter>
);
